const lang = {
  title: 'お知らせ',
  btn_return: '戻る',
  content:
    '2020年9月29日' +
    '<p class="mb-15">クラウド写真報告書『ZENGO』をリリース。</p>' +
    '2020年9月1日' +
    '<p class="mb-15">前後写真を同じアングルで撮影ができる『ZENGOカメラ』アプリを無料で提供開始。</p>'
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/notification.js